import {Tooltip, OverlayTrigger} from 'react-bootstrap'

class EmailField extends React.Component {
  render () {
    let {input, meta} = this.props
    let {touched, error} = meta
    return (
      <div className={`has-feedback ${touched ? (error ? 'has-error' : 'has-success') : ''}`}>
        <input {...input}
          type='text'
          className='form-control'
          placeholder='Email'
        />
        {this._icon()}
      </div>
    )
  }

  _icon = () => {
    const {input: {value}, meta: {error, touched}} = this.props

    if (touched && error) {
      return <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>{error}</Tooltip>}>
        <span
          className={`form-control-feedback glyphicon glyphicon-remove`}
          style={{'pointer-events': 'auto', 'cursor': 'pointer'}}
              />
      </OverlayTrigger>
    } else if (touched) {
      return <span />
    } else if (!touched && value) {
      return <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>Waiting For Verification</Tooltip>}>
        <span
          className={`form-control-feedback glyphicon glyphicon-time`}
          style={{'pointer-events': 'auto', 'cursor': 'pointer', 'color': '#e3a300'}}
                />
      </OverlayTrigger>
    }
  }

}

export default EmailField



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/StaffDetail/StaffForm/EmailField/EmailField.js